import { localStorage } from 'radio-components'
import Axios from 'axios'

import settings from '@config/site.yml?path=site.{rails_env}.public'
import hybrid from "@general/utils/appHybrid"

import withUserRequired from './withUserRequired'
import requiredForms from './formLoginRequired'

const storageKey = 'radio-auth-token'

let _store, currentUserToken

const watch = () => {
  // When another window sets a login token
  window.addEventListener('storage', (e) => {
    if (e.key == storageKey) {
      setLoginToken(e.newValue)
    }
  })

  setLoginToken(localStorage.getItem(storageKey))
}

const setLoginToken = (token) => {
  currentUserToken = token;

  // Access for legacy JS/Coffee code that's not being built with webpack
  window._currentUserToken = token;
  window._authenticated && window._authenticated(token)

  _store && _store.commit('user/USER_TOKEN_SET', token)
}

const isLoggedIn = () => !!currentUserToken

const refreshToken = async () => {
  // TODO: Limit this to only do one request
  try {
    const {
      data: {
        token: newToken
      }
    } = await Axios.post('/login/refresh')

    localStorage.setItem(storageKey, newToken)
    setLoginToken(newToken)

    return newToken
  } catch(e) {
    // Refreshing failed, log out user
    localStorage.removeItem(storageKey)
    setLoginToken(null)
  }
}

window.refreshToken = refreshToken

const loadSSO = () => {
  window.ssoConfig = {
    authorizeUrl: () => {
      return `${window.location.origin}/login?redirect_path=${window.location.pathname}`
    },
    logoutUrl: '/logout',
    topLevelDomain: settings.sso.topLevelDomain,
    logoUrl: settings.sso.logoUrl,
    bannerConfig: settings.sso.topLevelDomain == "be" ? "BE-TV/Radio" : "NL-Magazines",
    intraSsoEnabled: true,
    automaticLoginEnabled: true,
    loggedInEmail: _store.state.user.profile.email,
    multipleSessionsPopupEnabled: true,
  } 

  const script = document.createElement("script")
  script.src = "https://login-static.dpgmedia.net/ssosession/main.js"
  script.async = true
  script.onload = () => {
    window.ssoDetection.trigger(window.ssoConfig)
  }

  document.head.appendChild(script)
}

const installNativeAuthentication = () => {
  const callback = (user) => {
    window.nativeAppOpen = true
    if (user && user.radioToken) {
      setLoginToken(user.radioToken)
    }
  }

  hybrid.on('authenticated', callback)
  hybrid.on('appLoad', callback)
}

const install = (Vue, store) => {
  _store = store
  watch()

  Vue.component('auth-button', withUserRequired('button'))

  installNativeAuthentication()
  if (settings.sso) {
    loadSSO() 
  }
  requiredForms.init()
}

const onLogin = (callback) => {
  _store.watch(state => state.user.token, (newToken, oldToken) => {
    // A user is logged in
    if (newToken && !oldToken) {
      callback()
    }
  }, {immediate: true})
}

export {
  currentUserToken,
  refreshToken,
  isLoggedIn,
  onLogin
}

export default {
  install,
  onLogin
}
